import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {Link} from "../../raw-components/link/link";
import {BreadcrumbsItemBox} from "../boxes/breadcrumbs-item.box";

export interface BreadcrumbsItemComponentProps {
  readonly title: string;
  position: number;
  readonly url?: string;
  onClick?: () => void;

}

@observer
export class BreadcrumbsItemComponent extends OrbitComponent<BreadcrumbsItemComponentProps> {

    render() {

        const isClickable = Boolean(this.props.onClick);
        return (
            <>
                <BreadcrumbsItemBox isClickable={isClickable} itemProp={'itemListElement'} itemScope={true} itemType={'http://schema.org/ListItem'}>
                    <Link
                        itemProp={'item'}
                        href={this.props.url}
                        onClick={this.props.onClick}>
              <span itemProp={'name'}>
                {this.props.title}
              </span>
                        <meta itemProp={'position'} content={this.props.position.toString()}/>
                    </Link>
                </BreadcrumbsItemBox>
                {isClickable ? <span>{' > '}</span> : null}
            </>
        );
    }
}